/*Imports*/
import React from "react";
import * as CONSTANT from "constants/text";
import VerticalSpotlightDetails from "components/Spotlight/VerticalSpotlightDetails";
import CoverBanner from "components/Spotlight/CoverBanner";
import FriendMotivationalBanner from "components/Tribe/Friends/UserDetail/FriendMotivationalBanner";
import MyDefaultCoverPhoto from "site_media/images/DefaultCoverYosemite.png";
import FriendUserProfileBox from "components/Tribe/Friends/UserDetail/FriendUserProfileBox";
import "containers/Spotlight/MySpotlight.css";
import "components/Spotlight/Spotlight_Common.css";
import "containers/ProjectCommon.css";
import "containers/Tribe/Friends/UserDetail/PrivateUserProfile.css";
import "components/General/Form/CustomButton/TwoButtonLayout.css";
/*Group Invite helper methods*/
import * as Groups from "components/Tribe/Groups/GroupHelperMethods.js";
import * as FriendsSearchHelper from "components/Project/FriendsSearcHelper/FriendsSearchHelper";

class NonMemberGroupProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groupDetails: this.props.groupDetails,
      // phone: this.props.groupDetails.contact.split("__")[0],
      // email: this.props.groupDetails.contact.split("__")[1],
    };
  }
  //ref containers/Projects/StartProject/Step_3/StartProjectStepThree.js
  fetchFriendsData(obj, searchType, searchValue, page, searchMoreFlag) {
    FriendsSearchHelper.fetchGroupsDataHelper(
      obj,
      searchType,
      searchValue,
      page,
      searchMoreFlag,
      this.props.groupId
    );
  }

  render() {
    const { groupDetails } = this.props;
    return (
      <div className="header_main main_possible_friend">
        <div className="page_main main_page">
          <div id="vertical_spotlight_details">
            <VerticalSpotlightDetails isSpotlightPage={false} />
          </div>
          <div className="main_pane">
            <div className="cover_photo">
              <div className="padding_above_cover"></div>
              <CoverBanner
                cover={this.state.groupDetails.cover_pic || MyDefaultCoverPhoto}
                profile={groupDetails.group_pic}
              />
              <div className="padding_between"></div>
            </div>
            <div className="user_details">
              {this.props.match.params.type === CONSTANT.GUARDIAN_REVIEW ? (
                <FriendMotivationalBanner
                  type={CONSTANT.GUARDIAN_REVIEW}
                  groupName={this.props.groupDetails.name}
                  reviewChildGroupRequests={true}
                  declineOnClick={() =>
                    Groups.declineGaurdian(this.props.match.params.invite_id)
                  }
                  acceptOnClick={() =>
                    Groups.acceptGaurdian(this.props.match.params.invite_id)
                  }
                  isGroup={true}
                  // friendSlug={this.props.history.location.state.sentFrom}
                />
              ) : /*If the page was reached using the history object and includes a location state, use provided state*/
              this.props.history.location.state ? (
                this.props.history.location.state.inviteStatus ===
                CONSTANT.INVITE ? (
                  /*
                   * Use the this.props.history.location JSON object (instantiated in GroupListContainer)
                   * It contains the inviter's username, and the group_membership_invitation id, and group_id.
                   */
                  <FriendMotivationalBanner
                    type={CONSTANT.RECEIVED_INVITE_FROM_GROUP}
                    groupName={this.props.groupDetails.name}
                    declineOnClick={() =>
                      Groups.deleteInvite(
                        this.props.history.location.state.inviteId
                      )
                    }
                    acceptOnClick={() =>
                      Groups.acceptInvite(
                        this.props.history.location.state.userInvited,
                        this.props.groupDetails.id
                      )
                    }
                    friendSlug={this.props.history.location.state.sentFrom}
                     full_name={this.props.history.location.state.full_name}
                  />
                ) : this.state.groupDetails.invite_status ===
                  CONSTANT.REQUEST_LOWERCASE ? (
                  /*
                   * Use the this.props.history.location JSON object (instantiated in GroupListContainer)
                   * It contains the group_membership_invitation id.
                   */
                  <FriendMotivationalBanner
                    type={CONSTANT.GROUP_CANCEL_REQUEST_TITLE}
                    groupName={this.props.groupDetails.name}
                    cancelOnClick={() =>
                      Groups.deleteInvite(
                        this.props.history.location.state.inviteId
                      )
                    }
                  />
                ) : null
              ) : /*When the invite status is "none", role is "none" and the group is a PUBLIC group, render the join banner*/
              this.state.groupDetails.invite_status === "none" &&
                this.state.groupDetails.role === "none" &&
                this.state.groupDetails.visibility === CONSTANT.PUBLIC ? (
                <FriendMotivationalBanner
                  type={CONSTANT.JOIN_GROUP_TITLE}
                  groupName={this.props.groupDetails.name}
                  joinOnClick={() => Groups.join(this.state.groupDetails.id)}
                />
              ) : this.state.groupDetails.role === "none" &&
                this.state.groupDetails.visibility === CONSTANT.PRIVATE ? (
                <FriendMotivationalBanner
                  type={CONSTANT.JOIN_PRIVATE_GROUP}
                  groupName={this.props.groupDetails.name}
                  inviteDisabled={
                    this.state.groupDetails.invite_status === "none"
                  }
                  requestOnClick={() =>
                    Groups.request(this.state.groupDetails.id)
                  }
                />
              ) : null}
              <br />
              <FriendUserProfileBox
                full_name={groupDetails.name}
                type={CONSTANT.GROUPS}
                location={groupDetails.location}
                profilePic={groupDetails.group_pic}
                time={groupDetails.created_at}
                isMember={true}
              />
              <br />
              <h4 className="aboutMeTitle">{CONSTANT.ABOUT_US}</h4>
              <p>{groupDetails.description}</p>
              <h4 className="aboutMeTitle">{CONSTANT.GROUP_MISSION}</h4>
              <p>{groupDetails.mission}</p>
              <h4 className="aboutMeTitle">{CONSTANT.WE_SUPPORT}</h4>
              <ul>
                {groupDetails.project_interest &&
                groupDetails.project_interest.length > 0 ? (
                  groupDetails.project_interest.map((elem, index) => (
                    <li key={index}>{elem}</li>
                  ))
                ) : (
                  <div></div>
                )}
              </ul>
              <h4 className="aboutMeTitle">{CONSTANT.OUR_FAVORITE_CAUSES}</h4>
              <p>{groupDetails.causes}</p>
              <h4 className="aboutMeTitle">{CONSTANT.WEBSITE}</h4>
              <a
                href={'//'+groupDetails.website}
                target="_blank"
                style={{ marginBottom: "15px" }}
              >
                {groupDetails.website}
              </a>
              <h4 className="aboutMeTitle">{CONSTANT.CONTACT_INFO}</h4>
              {groupDetails.contact ? (
                <>
                  <div>{groupDetails.contact.split("__")[0]}</div>
                  <a href={"mailto:" + groupDetails.contact.split("__")[1]}>
                    {groupDetails.contact.split("__")[1]}
                  </a>
                  <br />
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NonMemberGroupProfile;
